export module MousedownOutsideDetector {

  export function attach(
    element: HTMLElement,
    downOutsideFn: (eventTarget: Element) => void
  ): () => void {
    const eventHanlder = (downEvent: MouseEvent) => {
      const target = downEvent.target;

      const containsElement = (currentElement: Element): boolean => {
        for (let i = 0; i < currentElement.children.length; i++) {
          if (currentElement.children[i] === target || containsElement(currentElement.children[i])) {
            return true;
          }
        }
        return false;
      };

      if (!containsElement(element)) {
        downOutsideFn(target as Element);
      }
    };

    document.addEventListener('mousedown', eventHanlder);

    return () => document.removeEventListener('mousedown', eventHanlder);
  }

}
